import { endpoints, baseurl } from "../Utils/Constants";

export const getAllIncentiveRatesForAccount = async (token) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ALL_INCENTIVE_RATES_FOR_ACCOUNT, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching incentive rates:", error);
        throw error;
    }
}

export const getAllIncentiveRates = async (token, organizationId) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_ALL_INCENTIVE_RATES + organizationId, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching incentive rates:", error);
        throw error;
    }
}

export const getIncentiveRateById = async (token, incentiveRateId) => {
    try {
        const response = await fetch(baseurl + endpoints.GET_INCENTIVE_RATE_BY_ID + incentiveRateId, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error fetching incentive rate by ID:", error);
        throw error;
    }
}

export const saveIncentiveRate = async (token, incentiveRateData) => {
    try {
        const response = await fetch(baseurl + endpoints.SAVE_INCENTIVE_RATE, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            },
            body: JSON.stringify(incentiveRateData)
        });
        return await response.json();
    } catch (error) {
        console.error("Error saving incentive rate:", error);
        throw error;
    }
}

export const deleteIncentiveRate = async (token, incentiveRateId) => {
    try {
        const response = await fetch(baseurl + endpoints.DELETE_INCENTIVE_RATE + incentiveRateId, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error deleting incentive rate:", error);
        throw error;
    }
}

export const loadIncentiveInsurances = async (token, organizationId) => {
    try {
        const response = await fetch(baseurl + endpoints.LOAD_INCENTIVE_INSURANCES + organizationId, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error loading insurances:", error);
        throw error;
    }
}

export const loadIncentiveCptCodes = async (token, organizationId) => {
    try {
        const response = await fetch(baseurl + endpoints.LOAD_INCENTIVE_CPT_CODES + organizationId, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error loading CPT codes:", error);
        throw error;
    }
}

export const loadIncentiveFacilities = async (token, organizationId) => {
    try {
        const response = await fetch(baseurl + endpoints.LOAD_INCENTIVE_FACILITIES + organizationId, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`
            }
        });
        return await response.json();
    } catch (error) {
        console.error("Error loading facilities:", error);
        throw error;
    }
}
